
import { CLIENTS } from '../../../../../helpers/constants'
import * as CreditsAndLimitsHelpers from './helpers'

export const CREDITS_LIMITS_TAB = {
  [CLIENTS.CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.CLEAROUTPHONE.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Phone Number Validator',
        accessorKey: 'limits.instant_phonenumber_validate_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantPhoneNumberValidatorFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.copDailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.copRemainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.copAllowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Phone Number Validator',
        accessorKey: 'limits.instant_phonenumber_validate_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantPhoneNumberValidatorFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.copDailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.copRemainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.copAllowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.EU_CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.CAMS_CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
  [CLIENTS.US_CLEAROUT.NAME]: {
    CREDITS_SECTION: [
      {
        label: 'Total Remaining Credits',
        accessorKey: 'credits.total',
        formatter: CreditsAndLimitsHelpers.totalRemainingCreditsFormatter,
      },
      {
        label: 'Pay As You Go Credits',
        accessorKey: 'credits.available',
        formatter: CreditsAndLimitsHelpers.payAsYouGoCreditsFormatter,
      },
      {
        label: 'Subscription Credits',
        accessorKey: 'credits.subs',
        formatter: CreditsAndLimitsHelpers.subscriptionCreditsFormatter,
      },
      {
        label: 'Recur Credits',
        accessorKey: 'credits.recur',
        formatter: CreditsAndLimitsHelpers.recurCreditsFormatter,
      },
    ],
    LIMITS_SECTION: [
      {
        label: 'API Rate Limit ',
        formatter: CreditsAndLimitsHelpers.apiRateLimitFormatter,
      },
      {
        label: 'Instant Email Verify',
        accessorKey: 'limits.instant_email_verify_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailVerifyFormatter,
      },
      {
        label: 'Parallel Bulk Email Verification Limit',
        accessorKey: 'maximum_request_queue_size.verify',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailVerifyFormatter,
      },
      {
        label: 'Instant Email Finder',
        accessorKey: 'limits.instant_email_finder_limit.maxRequests',
        formatter: CreditsAndLimitsHelpers.instantEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Email Finder Limit',
        accessorKey: 'maximum_request_queue_size.email_finder_bulk',
        formatter: CreditsAndLimitsHelpers.parallelBulkEmailFinderFormatter,
      },
      {
        label: 'Parallel Bulk Prospect Enrich Limit',
        accessorKey: 'maximum_request_queue_size.prospect.enrich_lead_list',
        formatter: CreditsAndLimitsHelpers.parallelBulkProspectEnrichFormatter,
      },
      {
        label: 'Daily Limit',
        formatter: CreditsAndLimitsHelpers.dailyLimitFormatter,
      },
      {
        label: 'Remaining daily limit',
        formatter: CreditsAndLimitsHelpers.remainingDailyLimitFormatter,
      },
      {
        label: 'Allowed daily limit',
        formatter: CreditsAndLimitsHelpers.allowedDailyLimitFormatter,
      },
    ],
    ACR_SECTION: [
      {
        label: 'Status',
        accessorKey: 'payment.auto_charge.credits.status',
        formatter: CreditsAndLimitsHelpers.acrStatusFormatter,
      },
      {
        label: 'Threshold',
        accessorKey: 'payment.auto_charge.credits.threshold',
        formatter: CreditsAndLimitsHelpers.acrThresholdFormatter,
      },
      {
        label: 'Quantity',
        accessorKey: 'payment.auto_charge.credits.quantity',
        formatter: CreditsAndLimitsHelpers.acrQuantityFormatter,
      },
      {
        label: 'Price',
        accessorKey: 'payment.auto_charge.credits.price.total_price',
        formatter: CreditsAndLimitsHelpers.acrPriceFormatter,
      },
      {
        label: 'Currency',
        accessorKey: 'payment.auto_charge.credits.currency',
        formatter: CreditsAndLimitsHelpers.acrCurrencyFormatter,
      },
      {
        label: 'Coupon',
        accessorKey: 'payment.auto_charge.credits.coupon',
        formatter: CreditsAndLimitsHelpers.acrCouponFormatter,
      },
    ]
  },
}